<template>
  <div :style="{ height: this.height }" class="scroll-box">
    <a-spin :spinning="loading">
      <a-timeline v-if="data.length > 0">
        <a-timeline-item v-for="history in data" :key="history.id">
          <p>
            <a-space>
              <span>{{ history.created_at }}</span>
              <span>{{ history.operation_type }}</span>
              <a-tooltip>
                <template slot="title">
                  {{ history.operator_name }}
                </template>
                <span>
                  <span>({{ history.operator_name | operatorNameFilter }})</span>
                </span>
              </a-tooltip>
            </a-space>
          </p>
          <div v-if="history.operation_type_value == 'sign_confirm_settlement'">
            <a-space>
              <span>客户签字确认结算单，存档：</span>
              <a @click="showPDF(history.pdf_url)" style="margin-top:5px;">查看详情</a>
            </a-space>
          </div>
          <div v-else>
            <p>{{ history.operation_content }}</p>
          </div>

          <div
            v-if="history.pictures && history.pictures.length > 0"
            :style="{ display: 'inline-block'}"
          >
            <a-space>
              <span>上传图片：</span>
              <div class="custom-flex custom-flex-wrap">
                <img
                  v-show="history.pictures"
                  v-for="(pic, index) in history.pictures"
                  :key="index"
                  :src="pic.url"
                  width="50px"
                  height="50px"
                  @click="showImg(pic.url)"
                  style="margin: 5px;"
                >
              </div>
            </a-space>
          </div>
        </a-timeline-item>
      </a-timeline>
      <a-empty v-else />
    </a-spin>
    <!-- 预览图片 -->
    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />
  </div>
</template>

<script>
import { findOperationHistories } from '@/api/operation_history'
import PreviewImage from '@/components/PreviewImage'
export default {
  name: 'OperationHistoryList',
  props: {
    serviceOrderId: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    orderType: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '400px'
    }
  },
  components: {
    PreviewImage
  },
  data() {
    return {
      loading: true,
      data: [],
      previewVisible: false,
      previewImage: undefined,
      reference_type: ''
    }
  },
  created() {
    this.fetchData()
  },
  filters: {
    operatorNameFilter(value) {
      if (value.length > 11) {
        return value.substring(0, 11) + '...'
      }
      return value
    }
  },
  methods: {
    showImg(pic) {
      this.previewVisible = true
      this.previewImage = pic
    },
    showPDF(url) {
      window.open(url, '_blank')
    },
    fetchData() {
      this.loading = true
      if (this.orderType === 'service') {
        this.reference_type = 'ServiceOrder'
      } else if (this.orderType === 'subscribe') {
        this.reference_type = 'SubscribeOrder'
      } else if (this.orderType === 'add_item') {
        this.reference_type = 'AdditionalItemOrder'
      }
      findOperationHistories({ reference_type: this.reference_type, reference_id: this.serviceOrderId }).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.scroll-box {
  overflow-y: auto;
  padding-top: 5px;
  padding-right: 10px;
}
</style>
